/**
 * absFigures.js — SINGLE SOURCE OF TRUTH for the headline national figures
 * and the site-wide "last verified" date.
 *
 * ─────────────────────────────────────────────────────────────────────
 * QUARTERLY REFRESH: when the next ABS Building Activity release lands
 * (next: 13 January 2027, September 2026 quarter), update the values in
 * THIS FILE ONLY. buildCostData.js, costIndexData.js, pillarSources.js,
 * the Melbourne money-page template and the LastVerifiedStamp all read
 * from here, so the whole site follows from one edit.
 * ─────────────────────────────────────────────────────────────────────
 */

// Site-wide freshness stamp (used on guide footers + Sources blocks).
export const SOURCES_LAST_VERIFIED = 'June 2026';
export const SOURCES_NEXT_REVIEW = 'October 2026';
// Calendar year currently cited on source lists (bump with the January release).
export const SOURCE_YEAR = '2026';

// Latest ABS Building Activity release currently cited across the site.
export const ABS_RELEASE = {
  period: 'June 2026 quarter',
  periodLong: 'June 2026 quarter (ABS, seasonally adjusted)',
  releasedLabel: 'June 2026 quarter, released October 2026',
  nextRelease: '13 January 2027 (September 2026 quarter)',

  // Value of building work done (seasonally adjusted, June 2026 quarter)
  valueTotal: '$45.8bn',
  valueTotalChange: '+1.1%',
  valueNewResidential: '$23.6bn',
  valueNewResidentialChange: '+1.4%',
  valueNewHouses: '$13.8bn',
  valueNewHousesChange: '+1.5%',

  // Dwelling commencements (seasonally adjusted, June 2026 quarter)
  totalCommencements: '52,201',
  totalChange: '+7.0% on the quarter',
  newHouseCommencements: '31,707',
  newHouseChange: '+11.6%',
  otherResidential: '19,126',
  otherResidentialChange: 'broadly flat',

  // Forward indicators (ABS Building Approvals & CPI)
  approvalsValue: '$529,790',
  dwellingInflation: '5.8%',
  constructionCostQoq: '+1.0%',

  sourceLine: 'ABS Building Activity, Australia (June 2026 quarter, released October 2026); ABS Building Approvals & CPI (June 2026); Cotality Cordell Construction Cost Index (June 2026 quarter)',
  url: 'https://www.abs.gov.au/statistics/industry/building-and-construction/building-activity-australia/latest-release',
};
